<template>
  <collapsed-card icon="md-document" title="Документы">
    <resources-editor />
  </collapsed-card>
</template>

<script>
import CollapsedCard from '@/components/parts/collapsed-card'
import ResourcesEditor from '@/components/resources/editor/resources-editor-contracts'

export default {
  components: {
    CollapsedCard,
    ResourcesEditor
  }
}
</script>

<style lang="less"></style>
